// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".acc-settings-nav-active[data-v-469ec8c9]{border-color:var(--acc-accent,#a84f1d)!important;box-shadow:0 0 0 1px var(--acc-accent,#a84f1d) inset;color:var(--acc-accent-foreground-light,#873b14)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
